import React, { useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../config";

const CardPOPUP = ({ banks = [], onAdd }) => {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ amount: "", name: "", time: "", mode: "Scan", bank_name: "" });

  const reset = () => setForm({ amount: "", name: "", time: "", mode: "Scan", bank_name: "" });

  const submit = async () => {
    if (!form.amount || !form.name || !form.bank_name) return;
    const token = localStorage.getItem("authToken");
    try {
      await axios.post(`${API_BASE_URL}/api/cardsave`, {
        token,
        name: form.name,
        amount: form.amount,
        bank_name: form.bank_name,
        mode: form.mode,
        time: form.time,
      }, { headers: { "Content-Type": "application/json" } });
      onAdd && onAdd({ ...form });
      reset();
      setOpen(false);
    } catch (e) {
      onAdd && onAdd({ ...form });
      reset();
      setOpen(false);
    }
  };

  return (
    <>
      <button type="button" className="btn btn-warning" onClick={() => setOpen(true)}>
        Add Card
      </button>
      {open && (
        <div className="modal d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add Card</h5>
                <button type="button" className="close" onClick={() => setOpen(false)}>
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="form-group">
                  <label>Amount</label>
                  <input type="number" className="form-control" value={form.amount} onChange={(e)=>setForm({...form, amount:e.target.value})} />
                </div>
                <div className="form-group">
                  <label>Name</label>
                  <input type="text" className="form-control" value={form.name} onChange={(e)=>setForm({...form, name:e.target.value})} />
                </div>
                <div className="form-group">
                  <label>Time</label>
                  <input type="text" className="form-control" placeholder="HH:MM" value={form.time} onChange={(e)=>setForm({...form, time:e.target.value})} />
                </div>
                <div className="form-group">
                  <label>Mode</label>
                  <select className="form-control" value={form.mode} onChange={(e)=>setForm({...form, mode:e.target.value})}>
                    <option>Scan</option>
                    <option>Swipe</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>Bank</label>
                  <input list="card-bank-suggestions" type="text" className="form-control" value={form.bank_name} onChange={(e)=>setForm({...form, bank_name:e.target.value})} />
                  <datalist id="card-bank-suggestions">
                    {banks.map((i,idx)=>(<option key={idx} value={i.name} />))}
                  </datalist>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={()=>setOpen(false)}>Close</button>
                <button type="button" className="btn btn-primary" onClick={submit}>Add</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CardPOPUP;
